/**
 * @name getLocaleTime
 * @param {string | string[]=} config
 * @param {Intl.DateTimeFormatOptions} options
 * @returns {string}
 */
var getLocaleTime = function (config, options) {
    if (config === void 0) { config = 'ru'; }
    var timeStamp = new Date();
    return timeStamp.toLocaleTimeString(config);
};

export { getLocaleTime };
